/*require('./../../../style/input-plugin/preview-image.less');*/
var $ = require('jQuery');
var template = require('./../../../template/input-plugin/preview-image.html');
var Plugin = require('./Plugin');
var ActionType = require('./../../../constant/ActionType');
var dispatcher = require('./../../../global/dispatcher');

var PreviewImagePlugin = function (options) {
    (function (self) {
        var defaults = {
            template: template
        };
        $.extend(defaults, options);
        Plugin.call(self, defaults);

        var fs = defaults.files;
        //图片预览
        self._element.show();
        //全屏事件打开
        dispatcher.dispatch({
            type: ActionType.FULLSCREEN_OPEN
        });
        var reader = new FileReader();
        reader.readAsDataURL(fs);
        reader.onload = function () {
            var data = this.result;
            //加载图片获取图片真实宽度和高度
            var image = new Image();
            image.src = data;
            var origin_width = 280;
            var origin_height = 210;
            image.onload = function () {
                self._width = image.width;
                self._height = image.height;
                self._src = data;
                self._element.find('.im-preview-image-pic').attr('src', data);
                //横图
                if (image.width / image.height > origin_width / origin_height) {
                    var height = (280 * image.height) / image.width;
                    self._element.find('.im-preview-image-pic').css({
                        'height': height + 'px',
                        'width': '280px'
                    })
                }
                else {
                    var width = (210 * image.width) / image.height;
                    self._element.find('.im-preview-image-pic').css({
                        'height': '210px',
                        'width': width + 'px'
                    })
                }
            };
        };
    })(this);

    (function (self) {
        self._element.find('.im-preview-image-primary-button').click(function () {
            self._input.send({
                type: 'image',
                url: self._src,
                image_width: self._width,
                image_height: self._height
            });
            self._element.hide();
            //全屏事件关闭
            dispatcher.dispatch({
                type: ActionType.FULLSCREEN_CLOSE
            });
        });

        self._element.click(function (e) {
            var target = $(e.target);
            if (target.hasClass('im-preview-image-default-button') || target.hasClass('im-preview-image-close') || target.parent().hasClass('im-preview-image-default-button')) {
                self._element.hide();
                //全屏事件关闭
                dispatcher.dispatch({
                    type: ActionType.FULLSCREEN_CLOSE
                });
            }
        });
    })(this);
};

PreviewImagePlugin.prototype = Object.create(Plugin.prototype);
module.exports = PreviewImagePlugin;